import axios from "axios";
import { API_HOST } from "@/core/variables";


class RoleRepository {
    find = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenarios/${scenarioId}/roles`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
}

const roleRepository = new RoleRepository();
export default roleRepository;

